import { postRostersByRosterIdEdit } from "@aura-frontend/omnibus-az-client";

import { getMemberExternalId } from "./omnibusMappers";
import { TeamRecord } from "./teamRoster";

/**
 * Sets a player's jersey number on the team's roster, where it lives (the
 * org player only holds name and handedness). The edit restates the roster's
 * members, changing only this one. Resolves to false, writing nothing, when
 * the player isn't a member.
 */
export const setRosterJerseyNumber = async (
  record: TeamRecord,
  playerId: string,
  jerseyNumber: string,
) => {
  const members = record.team.unofficial_members ?? [];
  if (!members.some((m) => getMemberExternalId(m) === playerId)) return false;
  await postRostersByRosterIdEdit({
    path: { roster_id: record.rosterId },
    body: {
      unofficialMembers: members.map((member) =>
        getMemberExternalId(member) === playerId
          ? { ...member, jerseyNumber: parseInt(jerseyNumber, 10) }
          : member,
      ),
    },
    throwOnError: true,
  });
  return true;
};
